import { action } from '@ember/object';
import Component from '@glimmer/component';

import ReportsViewerBlockCtComponent from 'webapp/components/reports/viewer/block-ct';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

export interface Args {
	model: ReportSlideFragment;
	isBeingEdited?: boolean;
}

export default class ReportsViewerFragmentStoryTextComponent<T extends Args> extends Component<T> {
	isEditable = false;

	@action
	bindBlockChange() {
		// do nothing, this is a viewer. will be extended in editor
	}
	<template>
		<div
			class="fragment fragment--story-text
				{{if @isBeingEdited 'fragment--story-text--being-edited'}}"
		>
			<div class="story-text-fragment-ct">
				<ReportsViewerBlockCtComponent
					@model={{@model}}
					@isEditable={{this.isEditable}}
					@onBlockReady={{this.bindBlockChange}}
				/>
			</div>
		</div>
	</template>
}
